// @flow

export const LOG_LEVELS = ['log', 'warn', 'error'];

export const logger = LOG_LEVELS.reduce((acc, level) => {
  // this is the one point where we should be calling console
  // eslint-disable-next-line no-console
  acc[level] = (...args: any[]) => console[level](...args);
  return acc;
}, {});
